/* eslint-disable no-unused-vars */
import React from 'react';
import * as S from '../ChooseApps.styled';
import Hightlighter from 'react-highlight-words';
import { ArrowDown, ArrowRightForSelectedGroup } from 'assets/icons';
import { Checkbox } from 'components';

const GroupComponent = ({
  groupName,
  toggleOpenedGroup,
  isGroupOpened,
  isGroupChecked,
  groupData,
  toggleAppsGroup,
  search,
  children,
}) => {
  const apps = groupData?.apps ? groupData.apps : groupData;

  return (
    <S.Group>
      <S.OpenGroupWrapper>
        <S.Row>
          <S.ArrowIconWrapper
            onClick={() => toggleOpenedGroup(groupName)}
            isOpen={isGroupOpened(groupName)}
          >
            {isGroupOpened(groupName) ? <ArrowDown /> : <ArrowRightForSelectedGroup />}
          </S.ArrowIconWrapper>
          <Checkbox
            id={`${groupName}`}
            isChecked={isGroupChecked(apps)}
            name={groupName}
            onChange={() => toggleAppsGroup(apps)}
            isOpenGroup
          />
          <S.GroupName>
            <Hightlighter
              textToHighlight={groupName}
              searchWords={[search]}
              highlightTag='strong'
            />
          </S.GroupName>
        </S.Row>
      </S.OpenGroupWrapper>
      <S.WrapForChooseRows>{children}</S.WrapForChooseRows>
    </S.Group>
  );
};

export default GroupComponent;
